import { httpClient } from '../api/http.client';

export interface PriceChartPoint {
  date: string;
  goatPrice?: number;
  poizonPrice?: number;
  stockxPrice?: number;
  nePrice?: number;
  sortagePrice?: number;
  wayoffPrice?: number;
  warehousePrice?: number;
}

export interface ShopPrices {
  inStock?: number;
  warehouse?: number;
  abroad?: number;
  abroadSource?: string;
}

export interface PriceSizeAnalytics {
  usSize: string;
  current?: PriceChartPoint;
  shopPrices?: ShopPrices;
  history: PriceChartPoint[];
}

export interface PriceAnalyticsResponse {
  sku: string;
  name: string;
  brand: string;
  sizes: PriceSizeAnalytics[];
}

export interface PriceCollectProgress {
  phase: string;
  totalProducts: number;
  processed: number;
  currentSku: string;
  recordsWritten: number;
  errors: number;
}

export interface PriceCollectStatus {
  isRunning: boolean;
  progress?: PriceCollectProgress;
}

export interface PriceProductItem {
  sku: string;
  name: string;
  brand: string;
  imageUrl: string;
  sizesCount: number;
  lastCollected: string;
  sampleSize: string;
  goatPrice?: number;
  poizonPrice?: number;
  stockxPrice?: number;
  sortagePrice?: number;
  wayoffPrice?: number;
  warehousePrice?: number;
}

export class PriceAnalyticsRepository {
  async getAnalytics(sku: string): Promise<PriceAnalyticsResponse> {
    return httpClient.get<PriceAnalyticsResponse>(`/api/admin/price-analytics/${encodeURIComponent(sku)}`);
  }

  async getProducts(limit: number = 20, offset: number = 0, search: string = ''): Promise<{ products: PriceProductItem[]; total: number }> {
    const params = `limit=${limit}&offset=${offset}${search ? `&search=${encodeURIComponent(search)}` : ''}`;
    return httpClient.get<{ products: PriceProductItem[]; total: number }>(`/api/admin/price-analytics/products?${params}`);
  }

  async triggerCollect(): Promise<{ message: string }> {
    return httpClient.post<{ message: string }>('/api/admin/price-analytics/collect');
  }

  async cancelCollect(): Promise<{ message: string }> {
    return httpClient.post<{ message: string }>('/api/admin/price-analytics/cancel');
  }

  async getStatus(): Promise<PriceCollectStatus> {
    return httpClient.get<PriceCollectStatus>('/api/admin/price-analytics/status');
  }
}

export const priceAnalyticsRepository = new PriceAnalyticsRepository();
